export default __webpack_public_path__ + "static/media/practice-test-5.5c63a1b2.csv";